export const UPDATE_WEIGHT_DISPUTE_SUCCESS = "UPDATE_WEIGHT_DISPUTE_SUCCESS";
export const UPDATE_WEIGHT_DISPUTE_REQUEST = "UPDATE_WEIGHT_DISPUTE_REQUEST";
export const UPDATE_WEIGHT_DISPUTE_FAILURE = "UPDATE_WEIGHT_DISPUTE_FAILURE";
export const UPDATE_WEIGHT_DISPUTE_RESET = "UPDATE_WEIGHT_DISPUTE_RESET";
export const updateWeightDisputeSuccess = (payload) => ({
    type: UPDATE_WEIGHT_DISPUTE_SUCCESS,
    payload,
});
export const updateWeightDisputeRequest = (payload) => ({
    type: UPDATE_WEIGHT_DISPUTE_REQUEST,
    payload,
});
export const updateWeightDisputeFailure = (payload) => ({
    type: UPDATE_WEIGHT_DISPUTE_FAILURE,
    payload,
});
export const updateWeightDisputeReset = () => ({
    type: UPDATE_WEIGHT_DISPUTE_RESET,
});
